import { render, staticRenderFns } from "./MovementCase.vue?vue&type=template&id=1147964f&scoped=true&"
import script from "./MovementCase.vue?vue&type=script&lang=js&"
export * from "./MovementCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1147964f",
  null
  
)

export default component.exports